import { useEffect } from 'react';

import { isMarketingDomain } from '../utils/domain';

/**
 * Domain redirect hook for auth pages
 *
 * Problem: The marketing site (hr4india.com) is hosted on S3/CloudFront without a backend API.
 * Auth pages require API calls which only work on okrhub.hr4india.com (EC2/nginx).
 *
 * This hook redirects users from marketing domains to the OKR Hub app domain for auth operations.
 *
 * Note it is isMarketingDomain and NOT `!isAppDomain` that belongs here: on localhost the
 * auth pages must work in place, and redirecting a developer to the live site would make
 * local auth work impossible.
 */

// Re-exported because this module was the original home of the predicate; utils/domain is
// now the single definition shared with App, LandingNav and the API client.
export { isMarketingDomain };

/**
 * Get the OKR Hub app URL for the current path
 * In production, this redirects to okrhub.hr4india.com
 */
export const getOkrHubUrl = (path: string = window.location.pathname): string => {
  const search = window.location.search; // Preserve query params
  return `https://okrhub.hr4india.com${path}${search}`;
};

/**
 * Hook to redirect from marketing domain to OKR Hub app domain
 * Use this in auth pages that require API calls
 *
 * @param path - Optional path override (defaults to current pathname)
 */
export const useDomainRedirect = (path?: string): void => {
  useEffect(() => {
    if (isMarketingDomain()) {
      window.location.href = getOkrHubUrl(path);
    }
  }, [path]);
};
